import { DataItemList } from "@/Features/Companies/Components/CompanyData";
import { Audit } from "@/interfaces/Company";
import { Timeline } from "antd";
import { TimeLineItemProps } from "antd/es/timeline/TimelineItem";
import React, { useEffect, useState } from "react";

interface HistoryTimeLineProps {
  audits: Audit[];
}

export default function HistoryTimeLine({ audits }: HistoryTimeLineProps) {
  const [items, setItems] = useState<TimeLineItemProps[]>([]);

  const sortedAudits = [...audits].sort((a, b) => b.id - a.id);

  const highestId = Math.max(...sortedAudits.map((a) => a.id));
  useEffect(() => {
    if (audits) {
      const newItems = sortedAudits.map((a) => ({
        color: a.id === highestId ? "red" : "blue",
        children: <DataItemList data={a} dataType="audits" />,
      }));

      setItems(newItems);
    }
  }, [audits]);
  return (
    <>
      <Timeline className="w-2/3" mode="alternate" items={items} />
    </>
  );
}
